export default "__VITE_ASSET__47153609__"